export default function(o, subsRaw, horizontaOffset){

  var subs = []

  var setSubsRaw = function(s){
    if(!s){
      subs = []
    } else {
      subs = o.util.parseSubs(o, s)
    }
  }

  setSubsRaw(subsRaw)

  var update = function(currentTime){
    var currentSub = _.find(subs, function(s){
      return s.s < currentTime && s.e > currentTime
    })
    if(currentSub){
      div.html(currentSub.t)
    } else {
      div.html('&nbsp;')
    }
  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      fontSize: o.fontSizeDef.s,
      padding: '1rem ' + horizontaOffset + 'px',
      textTransform: 'none',
      lineHeight: '1.3em',
      margin: '0 1rem',
    })
    .append(
      '&nbsp;'
    )

  div.update = update
  div.setSubsRaw = setSubsRaw

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/story/subs/subs.js